module.exports = __webpack_public_path__ + "img/SocksCoverArt.de634d43.png";